import React from 'react';

interface PlacementCustomCardProps {
	title: string;
	description: string;
	imageSrc: string;
	// onClick: () => void;
	// selected: boolean;
	// disabled: boolean;
	// badge?: string;
	// onBack?: () => void;
}

const PlacementCustomCard: React.FC<PlacementCustomCardProps> = ({
    title,
    description,
    imageSrc,
    // onClick,
    // selected,
    // disabled,
    // badge,
    // onBack,
}) => {
    return (
        <div 
        className='flex w-full md:w-[298px] px-1 md:px-0 md:items-center gap-[10px] flex-shrink-0 self-stretch'>
            <div className='w-[60px] flex justify-center items-center'>
                <img 
                className='full'
                src={imageSrc} alt={title} />
            </div>
            <div className='w-[304px] md:w-[230px] pr-[8px] md:!pr-[0px]'>
                <h1 className='text-[#28293D] font-inter text-[20px] font-[700] leading-[120%]'>{title}</h1>
                <p className='text-[#555770] mt-1 font-inter text-[12px] font-[400] leading-[133%]'>{description}</p>
            </div>
        </div>
    );
};

export default PlacementCustomCard;
 